import { InMemoryCache, makeVar } from '@apollo/client'
import { getUser } from './services/auth'
import { getToStorage } from './utils/utils'

export const hasWindow = typeof window !== 'undefined'

const initialLoginState = {
  phoneNumber: '',
  countryId: 2,
}

export const isLoggedInVar = makeVar((hasWindow && !!getUser()?.user) || null)

export const selectedWalletVar = makeVar(getToStorage('selectedWallet'))

export const selectedContactVar = makeVar(getToStorage('selectedContact'))

export const selectedVoucherVar = makeVar(getToStorage('selectedVoucher'))

export const selectedSendVoucherVar = makeVar(
  getToStorage('selectedSendVoucher'),
)

export const selectedPartnerVar = makeVar(getToStorage('selectedPartner'))

export const countrySelectedInfoVar = makeVar(
  getToStorage('countrySelectedInfo'),
)

export const selectedTagVar = makeVar(getToStorage('selectedTag'))

export const pushMoneyUserVar = makeVar(getUser() || null)

export const loginStateVar = makeVar(initialLoginState)

export const cache = new InMemoryCache({
  typePolicies: {
    Partner: {
      keyFields: ['id', 'aliasId'],
    },
    Query: {
      fields: {
        isLoggedIn: {
          read: () => {
            const isLoggedIn = isLoggedInVar()
            return isLoggedIn
          },
        },
        loginState: {
          read: () => {
            const loginState = loginStateVar()
            return loginState
          },
        },
        selectedTag: {
          read: () => selectedTagVar(),
        },
        selectedWallet: {
          read: () => {
            const selectedWallet = selectedWalletVar()
            return selectedWallet
          },
        },
        selectedContact: {
          read: () => selectedContactVar(),
        },
        selectedVoucher: {
          read: () => {
            const selectedVoucher = selectedVoucherVar()
            return selectedVoucher
          },
        },
        selectedSendVoucher: {
          read: () => {
            const selectedSendVoucher = selectedSendVoucherVar()
            return selectedSendVoucher
          },
        },
        selectedPartner: {
          read: () => {
            const selectedPartner = selectedPartnerVar()
            return selectedPartner
          },
        },
        pushMoneyUser: {
          read: () => {
            const pushMoneyUser = pushMoneyUserVar()
            return pushMoneyUser
          },
        },
        countrySelectedInfo: {
          read: () => {
            const countrySelectedInfo = countrySelectedInfoVar()
            return countrySelectedInfo
          },
        },
      },
    },
  },
})
